import { useQuery } from "@tanstack/react-query";
import { ApiResponse } from "../../apis/data";
import { queryKey } from "../../enumerations/queryKey";
import { UserLevelResponse } from "./data";
import { apiGetUserLevels } from "./service";

export const useGetUserLevels = (options: any) => {
  return useQuery<UserLevelResponse[]>({
    queryKey: [queryKey.USER_LEVEL_LIST],
    queryFn: () =>
      apiGetUserLevels().then(
        (res: ApiResponse<UserLevelResponse[]>) => res.data.data
      ),
    ...options,
  });
};
